export const ADD_USERS_COURSE_PAGE_KEY =
  'b2b-admin-dashboard-assign-user-course';
export const FIRST_DATA = 15;

export const AVATAR_SRC =
  'https://crehana-vercel-images-prd.imgix.net/public/ca166738-392d-4b34-8c28-9f7cf9251fc8-avatar-default-purple.png';

export const DEFAULT_IMG =
  'https://s3.amazonaws.com/public-catalog.crehana.com/images/app/gallery/2023/12/20/d08e784f/b3b57c7c.jpg';
export const DEFAULT_ASSIGN =
  'https://crehana-public-catalog.imgix.net/images/app/gallery/2024/11/08/c82d74f1/8fe13879.png';
export const DEFAULT_ASSIGN_SYNC =
  'https://crehana-public-catalog.imgix.net/images/app/gallery/2024/11/08/9d223aeb/4797d7c0.png';

export const ASTERISKS_CONTENT_REGEX = /\*(.*?)\*/;
